import { Box, styled } from '@mui/material';

export const PersonalDataStepContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '500px',
  gap: theme.spacing(3),
  [theme.breakpoints.up('md')]: {
    minWidth: theme.spacing(60)
  },
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(2),
    width: '100%'
  },
  '@media (max-height: 700px)': {
    gap: theme.spacing(2)
  }
}));

export const NameContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(2),
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: theme.spacing(3)
  }
}));

export const QuantityCarContainer = styled(Box)(() => ({
  width: '100%'
}));
